// vue
import { useStore } from '@/store';

// hooks
import { useAxios } from '@/vue3/hooks/axiosHook';
import { PinzoneExternalEmbedConfig as PinzoneExternalEmbedConfigInterface } from '@/vue3/api/models/';

export const usePinzoneExternalEmbedSiteService = () => {
    // hooks
    const { apiUrl } = useStore().state;
    const axios = useAxios();

    // reactive

    // methods
    const getPinzoneExternalEmbedSites = async (): Promise<PinzoneExternalEmbedConfigInterface[]> => {
        const res = await axios.get(`${apiUrl}/pinzone-external-embed/configs`);
        return res.data;
    };

    const getPinzoneExternalEmbedSiteById = async (id: number): Promise<PinzoneExternalEmbedConfigInterface> => {
        const res = await axios.get(`${apiUrl}/pinzone-external-embed/config/${id}`);
        return res.data;
    };

    const createPinzoneExternalEmbedSite = async (site_config: PinzoneExternalEmbedConfigInterface): Promise<any> => {
        const res = await axios.post(`${apiUrl}/pinzone-external-embed/config`, site_config);
        return res.data;
    };

    const updatePinzoneExternalEmbedSite = async (site_config: PinzoneExternalEmbedConfigInterface): Promise<any> => {
        const res = await axios.put(`${apiUrl}/pinzone-external-embed/config`, site_config);
        return res.data;
    };

    const deletePinzoneExternalEmbedSite = async (id: number) => {
        const res = await axios.deleteId(`${apiUrl}/pinzone-external-embed/config/${id}`);
        return res.status;
    };

    return {
        getPinzoneExternalEmbedSites,
        getPinzoneExternalEmbedSiteById,
        createPinzoneExternalEmbedSite,
        updatePinzoneExternalEmbedSite,
        deletePinzoneExternalEmbedSite
    };
};
